module.exports = __webpack_public_path__ + "img/BOTELLAROSEAPPLE.48e5535b.png";